module.exports = __webpack_public_path__ + "static/img/pdf4.a7783614.jpg";